import { helper, fileHelper } from "./common/InteropHelper";

//#region 代码编辑器
import "./components/codeEditor/index";
//#endregion

//#region 地图交互
import { MapInterop, analysis, analysisNames } from "./components/vMap/index";

(() => {
    const mapInterop = new MapInterop();
    let aanAnalysis = <any>analysis;
    for (let key in aanAnalysis) {
        if (aanAnalysis.hasOwnProperty(key)) {
            mapInterop.registerAnalysis(key, aanAnalysis[key]);
        }
    }

    window.VGIS.vMap = mapInterop;
    window.VGIS.helper = helper;
    window.VGIS.file = fileHelper;
    window.vMap = window.VGIS.vMap;
    //(<any>window).helper = helper;
})();

//#endregion

